/* Polsk katalog for locale-invoice-payment-actions-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'inv.pay.undoPayment': 'Cofnij płatność',
  'inv.pay.undoRefund': 'Cofnij zwrot',
  'inv.pay.undoPaymentTitle': 'Cofnąć zarejestrowaną płatność?',
  'inv.pay.undoRefundTitle': 'Cofnąć zarejestrowany zwrot?',
  'inv.pay.undoPaymentBody': 'Płatność zostanie wycofana, a faktura ponownie otwarta z odpowiednią kwotą do zapłaty. Pierwotne księgowanie pozostaje w historii.',
  'inv.pay.undoRefundBody': 'Zwrot zostanie wycofany, a nadpłata klienta ponownie otwarta. Pierwotne księgowanie pozostaje w historii.',
  'inv.toast.paymentReversed': 'Płatność została wycofana',
  'inv.toast.refundReversed': 'Zwrot został wycofany',
  'inv.err.paymentReverseFailed': 'Nie udało się wycofać płatności.',
  'inv.err.refundReverseFailed': 'Nie udało się wycofać zwrotu.',
});
